export default __webpack_public_path__ + "static/media/avatar_fa.ded9fd6b.png";